import { reactive } from 'vue'

class EventBus {
  constructor() {
    this.events = reactive({})
  }

  $on(eventName, callback) {
    if (!this.events[eventName]) {
      this.events[eventName] = []
    }
    this.events[eventName].push(callback)
  }

  async $emit(eventName, value, subValue) {
    if (this.events[eventName]) {
      for (const callback of this.events[eventName]) {
        console.time('EventBus')
        await callback(value, subValue)
        console.timeEnd('EventBus')
      }
    }
  }

  $off(eventName, callback) {
    if (this.events[eventName]) {
      const index = this.events[eventName].indexOf(callback)
      if (index > -1) {
        this.events[eventName].splice(index, 1)
      }
    }
  }
}

export default new EventBus()
